import { LanguageInitializationService } from '../services/languageInitializationService';

/**
 * Global function to initialize language service (similar to authManagement pattern)
 * @param {Object} props - Configuration props from server
 * @returns {Promise<boolean>} Whether initialization completed successfully
 */
window.initializeLanguageService = async (props) => {
  try {
    console.debug('[LanguageInitialization] Starting service initialization');
    
    const service = new LanguageInitializationService();
    service.initialize(props);
    
    const success = await service.execute();
    
    if (success) {
      console.debug('[LanguageInitialization] Service initialization completed');
    }
    
    // Store service instance for manual operations if needed
    window.languageInitializationService = service;
    
    return success;
  } catch (error) {
    console.error('[LanguageInitialization] Service initialization failed:', error);
    return false;
  }
};

